import {
    IOrganization,
    IOrganizationInvitation,
    IOrganizationMember,
    IRorResponseItem,
} from '@vivli/features/organizations/infrastructure/interface';
import { createContext, useContext } from 'react';
import { IUser, IVivliRoleDef } from '@vivli/shared/infrastructure/interface';
import { GridApi } from 'ag-grid-community';

interface IOrganizationDetailsContext {
    organization?: IOrganization;
    invitations?: IOrganizationInvitation[];
    handleSave?: (updatedOrg) => void;
    isSaving?: boolean;
    addOrgMember?: (invite) => void;
    deleteInvite?: (invite) => void;
    getRorMatches?: (searchTerm) => IRorResponseItem[];
    currentMembers?: IOrganizationMember[];
    setCurrentMembers?: React.Dispatch<React.SetStateAction<IOrganizationMember[]>>;
    handleRoleUpdate?: (
        orgId: string,
        fieldName: string,
        userToUpdate: IUser,
        setIsLoading: React.Dispatch<React.SetStateAction<boolean>>
    ) => void;
    updatedUser?: IOrganizationMember;
    isLoading?: boolean;
    rolesOrgSpecific?: IVivliRoleDef[];
    isMemberTab?: boolean;
    setIsMemberTab: React.Dispatch<React.SetStateAction<boolean>>;
    showAddMemberPopup: () => void;
    membersGridApiRef?: React.MutableRefObject<GridApi>;
}

export const OrganizationDetailsContext = createContext<IOrganizationDetailsContext>(null);

export const useOrganizationDetailsContext = () => useContext(OrganizationDetailsContext);
